<template>
  <div v-if="label && labelPosition === 'above'">{{ $t(label) }} {{ required ? " *" : "" }}</div>
  <v-select
    id="ticket-status-selection"
    v-model="status"
    v-bind="$attrs"
    :items="statuses"
    :menu-props="{ maxHeight: '800px' }"
    :rules="required ? [(val) => !!val || $t('validation.required')] : undefined"
    :label="label && labelPosition === 'inside' ? $t(label) : undefined"
  >
    <template #selection="{ item }">
      <ticket-status-badge :status="item" />
    </template>

    <template #item="{ item, props: itemProps }">
      <v-list-item class="py-2" v-bind="itemProps" :title="undefined">
        <div class="d-flex ga-2 align-center">
          <v-icon icon="arrow_forward" size="small" class="text-grey" />
          <ticket-status-badge :status="item" />
        </div>

        <div class="text-body-medium mt-1 text-medium-emphasis" style="max-width: 500px">
          {{ $t(`tickets.status.status.${item}.description`) }}
        </div>
      </v-list-item>
    </template>
  </v-select>
</template>

<script setup lang="ts">
const status = defineModel<TicketStatus>()

const {
  statuses,
  labelPosition = "above",
  label = undefined,
  required = false,
} = defineProps<{
  statuses: TicketStatus[]
  labelPosition?: "above" | "inside" | "none"
  label?: string
  required?: boolean
}>()
</script>
